import React from 'react';
import {Paper,Typography, Divider, Button, Icon} from 'material-ui';
import {withStyles} from 'material-ui/styles';
import Moment from 'react-moment'; 

// Components
import NoQuoteCard from './NoQuoteCard';
import QuoteCard from './QuoteCard';




// custom styling
const primaryColor = '#2ba46f';
const disabledText = '#d8d8d8';
const backgroundWhite = '#fff';

const style = {
    root: {
        'padding': '16px'
    },
    archive_button_root: {

        'background': backgroundWhite,
        'text-transform':'inherit',
        'padding': '16px 0',
        'color': primaryColor
    },
    archive_button_disabled:{
        'background-color': backgroundWhite,
        'color': disabledText
    },
    header_meta_text: {
        'font-size': '0.65em'
    }
   
}


/*
 * getDate
 * Returns day or month to be used in header
 */ 
function getDate(type){
    let date = new Date()
    let month_array = ['JAN', 'FEB', 'MAR', 'APR', 'MAY','JUN', 'JUL', 'AUG', 'SEP','OCT', 'NOV', 'DEC']

    if (type === 'day'){
        return ''+date.getDate()  
    }

    return month_array[date.getMonth()]
}

function parseSentiment(sentiment){
    let sentimentP = parseFloat(sentiment);
    sentimentP = Math.round(sentimentP*100);

    if(sentimentP <= 25){
        return "Very negative!";
    }else if(sentimentP <=50){
        return "Negative to neutral";
    }else if(sentimentP <= 75){
        return "Positive";
    }else{
        return "Very positive";
    }
}

/*
 * countCharacters
 * counts characters in the quote to be used in header
 */ 
function countwords(text){
    let wordArr = text.split(" ")
    return wordArr.length
}

/*
 * Bottom panel is common to both QuoteView and noQuoteView
 * So that's why it has separate component (to avoid redundancy)
 */
function RenderBottomPanel(props){
    return (
        <div className="bottom-bar">
            <Divider/>
            <Button fullWidth={true} disabled={props.disabled} size="large" classes = {{ 
                root: props.classes.archive_button_root,
                disabled: props.classes.archive_button_disabled }}>
            
                <Icon color="inherit" style={{marginRight: '16px'}}>inbox</Icon>
                <Typography color="inherit" variant="body2" >Go to Archive</Typography>
            </Button>
        </div>
    )
}


/*
 * This renders the Empty Quote view, when there is
 * no quote available in database
 */

function RenderNoQuoteView(props){

    return(
        <div className="flex flex-auto layout-column">
            <Paper classes = {{ root: props.classes.root }} spacing={24} className="flex flex-auto layout-column overflow-h" square={true} elevation={0}>
                <NoQuoteCard/>
            </Paper>
            <RenderBottomPanel disabled={true} classes={props.classes}/>
        </div>
    )

}




/*
 * RenderQuoteView
 * This renders the QuoteView that includes top panel 
 * and quote content
 */ 

function RenderQuoteView(props){
    let imgObj = {}
    if(props.quote.type === 'photo'){
       imgObj = props.quote.content;
       imgObj = imgObj.replace(/\'/g,'"')
       imgObj = JSON.parse(imgObj)
       let imgSrc = imgObj['original_size'].url
        return( 
            <div className="flex flex-auto layout-column ">
                <Paper className="flex layout-row" elevation={0} classes = {{ root: props.classes.root }} spacing={24}>
                    <div className="flex flex-auto layout-column">
                        <Typography classes={{
                                root: props.classes.header_meta_text
                            }}
                            style={{fontWeight: '700'}}
                            variant="caption">TODAY'S QUOTE</Typography>
                        
                        <Typography classes={{
                                root: props.classes.header_meta_text
                            }}
                            style={{color: '#aaa'}}
                            variant="caption">
                                <Moment fromNow>{props.quote.received}</Moment>
                            </Typography>
                        
                        
                    <div style={{display:'inline-block', marginTop:'10px'}}>
                    <a href={props.quote.url} className="primary-link header-link" target="_blank">Open in Tumblr</a>
                    </div>

                        
                    </div>
                    <div className="flex layout-column justify-center current-date-container">
                        <div >
                            <Typography className="text-center" style={{fontWeight: '200'}} color="primary" variant="title">{getDate('day')}</Typography>
                            <Typography variant="caption">{getDate('month')}</Typography>
                        </div>
                    </div>
                </Paper>
                <Divider/>
                <div className="flex flex-auto layout-column justify-center">
                    <img alt={imgObj.caption} style={{width:'100%'}} src={imgSrc}/>
                </div>

                <RenderBottomPanel disabled={false} classes={props.classes}/>
            </div>
       )
    }
    return(

        <div className="flex flex-auto layout-column">
            <Paper className="flex layout-row" elevation={0} classes = {{ root: props.classes.root }} spacing={24}>
                <div className="flex flex-auto layout-column">
                    <Typography classes={{
                            root: props.classes.header_meta_text
                        }}
                        style={{fontWeight: '700'}}
                        variant="caption">TODAY'S QUOTE</Typography>
                    
                    <Typography classes={{
                            root: props.classes.header_meta_text
                        }}
                        style={{color: '#aaa'}}
                        variant="caption">
                            <Moment fromNow>{props.quote.received}</Moment>
                        </Typography>
                    <Typography classes={{
                            root: props.classes.header_meta_text
                        }}
                        style={{color: '#aaa'}}
                        variant="caption">{countwords(props.quote.content)} words</Typography>
                    
                    
                   <div style={{display:'inline-block', marginTop:'10px'}}>
                   <a href={props.quote.url} className="primary-link header-link" target="_blank">Open in Tumblr</a>
                   </div>

                    
                </div>
                <div className="flex layout-column justify-center current-date-container">
                    <div >
                        <Typography className="text-center" style={{fontWeight: '200'}} color="primary" variant="title">{getDate('day')}</Typography>
                        <Typography variant="caption">{getDate('month')}</Typography>
                    </div>
                </div>
            </Paper>
            <Divider/>
            <Paper classes = {{ root: props.classes.root }} spacing={24} className="flex flex-auto layout-column overflow-h" square={true} elevation={0}>
                <QuoteCard quote={props.quote}/>
            </Paper>
            <RenderBottomPanel disabled={false} classes={props.classes}/>
        </div>

    )
}




class AppView extends React.Component {
    

    //constructor
    constructor(props){
        super(props)

    }
    

    //render function
    render(){
        // check if we have quotes
        let hasQuote = this.props.quote.content === undefined?false:true;
        
        if(!hasQuote){
            //render noquote
            return(
                <RenderNoQuoteView classes={this.props.classes}/>
            )
        }
        //render quote view
        return( 
            <RenderQuoteView quote={this.props.quote} classes={this.props.classes}/>
        )

    }
}


export default withStyles(style)(AppView)



// WEBPACK FOOTER //
// ./src/Components/AppView.js